import { API, generic } from "api"

export default class CourseSubscriptionsService {
  static create = async ({ pageState, courseId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_COURSE_SUBSCRIPTIONS_CREATE_STATUS",
      stateDataKey: ["courseSubscription"],
      stateErrorKey: ["courseSubscriptionCreateErrors"],
      apiEndpoint: API.students.course_subscriptions.create,
      apiUrlReplacements: {},
      apiData: { course_id: courseId },
      errorMessage: "Course Subscription could not be created"
    })
  }

  static payment = async ({ pageState, courseId, razorpayPaymentId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_COURSE_SUBSCRIPTIONS_PAYMENT_STATUS",
      stateDataKey: ["payment"],
      stateErrorKey: ["courseSubscriptionPaymentErrors"],
      apiEndpoint: API.students.course_subscriptions.payment,
      apiUrlReplacements: {},
      apiData: {
        razorpay_payment_id: razorpayPaymentId,
        course_id: courseId
      },
      errorMessage: "Payment detail cound not be fetched."
    })
  }
}
